import { TranslationWidth } from '@angular/common';
import { Injectable } from '@angular/core';
import { NgbDatepickerI18n, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { I18n, I18N_VALUES } from './I18n';

@Injectable()
export class CustomDatepickerI18n extends NgbDatepickerI18n {


  constructor(private _i18n: I18n) {
    super();
  }

  getWeekdayShortName(weekday: number): string {
    return I18N_VALUES[this._i18n.language].weekdays[weekday - 1];
  }
  getMonthShortName(month: number): string {
    return I18N_VALUES[this._i18n.language].months[month - 1];
  }
  getMonthFullName(month: number): string {
    return this.getMonthShortName(month);
  }

  getDayAriaLabel(date: NgbDateStruct): string {
    return `${date.day}-${date.month}-${date.year}`;
  }  
  
  getWeekdayLabel(weekday: number, width?: TranslationWidth): string {    
    return I18N_VALUES[this._i18n.language].weekdaysLabel[weekday - 1];
  }

}
